import m = require("mithril")
import {simpleContent} from "../helpers";
import {Draggable} from "../../components/draggable";
import {DragGroup} from "../../../model/groups/dragGroup";
import {DragValue} from "../../../model/items/dragdrop/dragItem";
import {Vnode} from "mithril";
import {Point} from "../../../model/utils";

export class DragValueView {
    public static component = {
        view: (vnode: Vnode) => {
            return m(DragValueView, vnode.attrs);
        }
    };
    private dragValue: DragValue;
    public readonly draggable: Draggable;

    constructor(attr: any) {
        this.dragValue = <DragValue>attr.attrs.dragValue;
        this.draggable = new Draggable({
            key: this.dragValue.value(),

            events: {
                onStart: (p: Point) => this.dragValue.emitDragEvent(DragGroup.Events.DRAG_START, p),
                onMove: (p: Point) => this.dragValue.emitDragEvent(DragGroup.Events.DRAG_MOVE, p),
                onDrop: (p: Point) => this.dragValue.emitDragEvent(DragGroup.Events.DRAG_DROP, p)
            },
            content: simpleContent(this.dragValue.parent, this.dragValue.parent.childrenTags)
        });
        // console.log("CV", this.dragValue.value());
    }

    view(): any {
        // console.log("DV", this.dragValue.value());
        return m(this.draggable);
    }

}